/**
 * Test IDs for QA automation.
 */
export const testIds = {
  driverShiftFormLabel: "driver-shift-form-label",
  driverShiftFormDomicile: "driver-shift-form-domicile",
  driverShiftFormAllDomicilesOption: "driver-shift-form-all-domiciles-option",
  driverShiftFormDomicileOption: "driver-shift-form-domicile-option",
  driverShiftFormDriversDefaultsToAll: "driver-shift-form-drivers-defaults-to-all",
  driverShiftFormDriverOption: "driver-shift-form-driver-option",
  driverShiftFormSave: "driver-shift-form-save",
} as const;
